import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceAudioQueuedStatus } from '../../services/AudioAnnouncementService';

export default function useGetDeviceAudioQueuedStatus(
  fleetId: string,
  deviceId: string,
  audioId: string,
): UseQueryResult<any> {
  return useQuery(
    ['device-audio-queued', fleetId, deviceId, audioId], // ✅ include audioId
    () => getDeviceAudioQueuedStatus(fleetId, deviceId, audioId),
    {
      retry: 1,
      enabled: Boolean(fleetId && deviceId && audioId), // ✅ key fix
      refetchOnWindowFocus: false,
    },
  );
}
